/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';
import {
    UserEtcResponse,
    UserEtcResponseFromJSON,
    UserEtcResponseFromJSONTyped,
    UserEtcResponseToJSON,
} from './UserEtcResponse';

/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    lastName: string | null;
    /**
     * 
     * @type {Array<Role>}
     * @memberof UserResponse
     */
    roles: Array<Role> | null;
    /**
     * 
     * @type {Date}
     * @memberof UserResponse
     */
    lastAuthenticatedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    lastActivity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    isLocked: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    isAuthenticationLocked: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    createdBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    modifiedBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserResponse
     */
    modifiedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    passwordAge: number | null;
    /**
     * 
     * @type {UserEtcResponse}
     * @memberof UserResponse
     */
    etc: UserEtcResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    mfaEnabled: boolean;
}

export function UserResponseFromJSON(json: any): UserResponse {
    return UserResponseFromJSONTyped(json, false);
}

export function UserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'roles': (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleFromJSON)),
        'lastAuthenticatedAt': (json['lastAuthenticatedAt'] === null ? null : new Date(json['lastAuthenticatedAt'])),
        'lastActivity': !exists(json, 'lastActivity') ? undefined : json['lastActivity'],
        'isLocked': json['isLocked'],
        'isAuthenticationLocked': json['isAuthenticationLocked'],
        'createdBy': json['createdBy'],
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'modifiedBy': json['modifiedBy'],
        'modifiedAt': (json['modifiedAt'] === null ? null : new Date(json['modifiedAt'])),
        'passwordAge': json['passwordAge'],
        'etc': UserEtcResponseFromJSON(json['etc']),
        'mfaEnabled': json['mfaEnabled'],
    };
}

export function UserResponseToJSON(value?: UserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'roles': (value.roles === null ? null : (value.roles as Array<any>).map(RoleToJSON)),
        'lastAuthenticatedAt': (value.lastAuthenticatedAt === null ? null : value.lastAuthenticatedAt.toISOString()),
        'lastActivity': value.lastActivity,
        'isLocked': value.isLocked,
        'isAuthenticationLocked': value.isAuthenticationLocked,
        'createdBy': value.createdBy,
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedAt': (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'passwordAge': value.passwordAge,
        'etc': UserEtcResponseToJSON(value.etc),
        'mfaEnabled': value.mfaEnabled,
    };
}

